import { render, staticRenderFns } from "./info.vue?vue&type=template&id=26f33c64"
import script from "./info.ts?vue&type=script&lang=js&external"
export * from "./info.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports